import { Provider } from '@angular/core';
import { DeviceIdentificationService } from './device-identification.service';

export function provideDeviceIdentification(): Provider[] {
  return [DeviceIdentificationService];
}
